




















import { Component, Vue } from 'vue-property-decorator';
import { Route } from 'vue-router';

import i18n from '@/i18n';
import store from '@/store';
import EventBus from '@/plugins/event-bus';
import { Meta } from '@/decorators';

import Slider from '@/components/blocks/home/Slider.vue';
import Contact from '@/components/blocks/home/Contact.vue';
import Statistics from '@/components/blocks/home/Statistics.vue';
import Covid19 from '@/components/blocks/home/Covid19.vue';

import IHomeMeta from '@/store/modules/home/types/IHomeMeta';
import { IHomeStatistics } from '@/store/modules/home/types/IHomeStatistics';
import { IHomeSlider } from '@/store/modules/home/types/IHomeSlider';
import { IHomeCovid19 } from '@/store/modules/home/types/IHomeCovid19';

import ColorFillContainer from '@/components/ui/shapes/ColorFillContainer.vue';

async function dataHook(to: Route, from: Route, next: (callback?: any) => void) {
  try {
    await store.dispatch('home/load');
    next(true);
  } catch (error) {
    store.commit('app/error', error, { root: true });
    next({ path: '/error' });
  }
}

@Component({
  components: {
    Slider,
    Contact,
    Statistics,
    Covid19,
    ColorFillContainer,
  },
})
export default class Home extends Vue {
  private get meta(): IHomeMeta {
    return this.$store.state.home.meta;
  }

  private get slider(): IHomeSlider {
    return this.$store.state.home.slider;
  }

  private get statistics(): IHomeStatistics {
    return this.$store.state.home.statistics;
  }

  private get covid19(): IHomeCovid19 {
    return this.$store.state.home.covid19;
  }

  @Meta
  public metaInfo() {
    return {
      title: this.meta.title,
      meta: [{
        vmid: 'description',
        name: 'description',
        content: this.meta.description,
      }],
    };
  }

  private mounted(): void {
    this.$nextTick(() => {
      this.$bus.$emit('progress-stop');
    });
  }

  private async beforeRouteEnter(to: Route, from: Route, next: (callback?: any) => void) {
    await dataHook(to, from, next);
  }
}
